var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { atom } from 'jotai/vanilla';
export var PUSH = 'push';
export var POP = 'pop';
export var INITIATE = 'initiate';
export var REPLACE = 'replace';
export var Tasks = {
    INITIAL: 'initial',
    SIGNUP_EMAIL: 'signupEmail',
    SIGNUP_KAKAO: 'signupKakao',
    LOGIN_EMAIL: 'emailLogin',
    LOGIN_KAKAO: 'emailKakao',
    SIGNUP_WELCOME: 'signupWelcome',
    FIND_EMAIL_INITIAL: 'findEmail',
    FIND_EMAIL_DONE: 'findEmailDone',
    CHANGE_PASSWORD_INITIAL: 'changePassword',
    CHANGE_PASSWORD_AUTH: 'changePasswordAuth',
    CHANGE_PASSWORD_ENTER: 'changePasswordEnter',
    CHANGE_PASSWORD_DONE: 'changePasswordDone',
    CHANGE_PHONE_NUMBER_ENTER_AND_AUTH: 'changePhoneNumberEnterAndAuth',
    CHANGE_PHONE_NUMBER_READY: 'changePhoneNumberReady',
    CHANGE_PHONE_NUMBER_DONE: 'changePhoneNumberDone',
    CHANGE_EMAIL_ENTER: 'changeEmailEnter',
    CHANGE_EMAIL_AUTH: 'changeEmailAuth',
    CHANGE_EMAIL_READY: 'changeEmailReady',
    CHANGE_EMAIL_DONE: 'changeEmailDone',
    EVENT_MARKETING_AGREEMENT: 'eventMarketingAgreement',
};
var modalHistoryAtom = atom([Tasks.INITIAL]);
var getLastElementOfArray = function (array) { return array[array.length - 1]; };
export var readModalHistoryAtom = atom(function (get) { return get(modalHistoryAtom); });
export var readWriteModalHistoryAtom = atom(function (get) { return getLastElementOfArray(get(modalHistoryAtom)); }, function (get, set, _a) {
    var action = _a.action, task = _a.task;
    var copied = __spreadArray([], get(modalHistoryAtom), true);
    switch (action) {
        case PUSH:
            if (task) {
                copied.push(task);
                set(modalHistoryAtom, copied);
                break;
            }
            break;
        case POP:
            var popped = copied.pop();
            set(modalHistoryAtom, copied);
            return popped;
        case REPLACE:
            if (task) {
                set(modalHistoryAtom, [task]);
                return [task];
            }
            break;
        case INITIATE:
            set(modalHistoryAtom, [Tasks.INITIAL]);
            break;
        default:
            break;
    }
});
export var emailAtom = atom('');
export var codeAtom = atom('');
export var phoneCodeAtom = atom('');
export var userAtom = atom(null);
export var hideGoBackBtnAtom = atom(false);
export var hideCloseBtnAtom = atom(false);
export var noBirthDateAtom = atom(false);
//# sourceMappingURL=index.js.map